<template>
    <div id="idImportarCsvModal">
        <Button class="btn-import-csv"
            :size="15" 
            color="#2da44e" 
            colorText="#ffffff" 
            tooltip="Importador Acuerdos Líneas" 
            icon="fas fa-upload" 
            round 
            :width="30"  
            translate 
            @click.native="openModal('importCsvModal')"
        />
        <ui-modal size="auto" ref="importCsvModal" :title="`Importador Acuerdos Líneas`" @close="closeModal('importCsvModal')">
            <div class="container-fluid mb-3">
                <div class="row">
                    <div class="col">
                        <small> - Los campos 'NETA (COSTO)' y 'PUBLICA (VENTA)' deben ser tipo númerico, con comas y puntos solo para decimales. Ej: 20,21 , 32.1 , 125  </small>
                        <br />
                        <small> - Los campos 'DESDE' y 'HASTA' deben tener el formato '01-12-2024'.</small>
                    </div>
                </div>
            </div>

            <div class="import-csv-modal">
                <div class="import-csv-modal__header">
                    <div class="import-csv-modal__header-import">
                        <div class="import-file">
                            <input class="import-file__input" 
                                type="file"
                                ref="fileToImport"
                                id="fileToImport"
                                name="fileToImport" 
                                @change="getFile()"
                                accept=".xlsx"
                            />
                            <span v-if="showDeleteBtn" class="import-file__delete" @click="clearInput()">
                                <i class="fas fa-trash-alt"></i>
                            </span>
                        </div>
                    </div>
                    <div class="import-csv-modal__header-info">
                        <span class="import-csv-modal__header-info-span">Con error: <div class="import-csv-modal__header-info-span-error"></div></span>
                        <span class="import-csv-modal__header-info-span">Modificar: <div class="import-csv-modal__header-info-span-modify"></div></span>
                        <span class="import-csv-modal__header-info-span">Agregar: <div class="import-csv-modal__header-info-span-create"></div></span>
                    </div>
                </div>
                <div class="import-csv-modal__body">
                    <table v-if="showTable" class="table table-bordered stripe display compact hover text-center">
                        <thead>
                            <tr>
                                <th>*</th>
                                <th>ID</th>
                                <th>Naviera</th>
                                <th>Naviera Salida</th>
                                <th>POL</th>
                                <th>POD</th>
                                <th>Desde</th>
                                <th>Hasta</th>
                                <th>TT</th>
                                <th>Neta (Costo)</th>
                                <th>Pública (Venta)</th>
                                <th>Descuento</th>
                                <th>Unidad</th>
                                <th>Commodity</th>
                                <th>Atmósfera</th>
                                <th>Trat. frío</th>
                                <th>Días Libres Origen</th>
                                <th>Días Plug Origen</th>
                                <th>Días Libres Destino</th>
                                <th>Días Plug Destino</th>
                                <th>Genset</th>
                                <th>Get Out</th>
                                <th>Tipo Contrato</th>
                                <th>Comentario</th>
                                <th>Contrato - Número</th>
                                <th>Recargos</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in dataFormatted" :key="index">
                                <td :class="item.id === 0 && 'data_modified'" :style="{ 'background-color': item.naviera.type }">{{ index + 1 }} </td>
                                <td :class="item.id === 0 && 'data_modified'" :style="{ 'background-color': item.naviera.type }">{{ item.id ?? "" }} </td>
                                <td :class="item.naviera.changed && 'data_modified'" :style="item.id=== 0 ? 'background-color: rgb(45, 164, 78)' : '' ">{{ item.naviera.value }} </td>
                                <td :class="item.navieraSalida.changed && 'data_modified'" :style="{ 'background-color': item.navieraSalida.type }">{{ item.navieraSalida.value }} </td>
                                <td :class="item.pol.changed && 'data_modified'" :style="{ 'background-color': item.pol.type }">{{ item.pol.value }}</td>
                                <td :class="item.pod.changed && 'data_modified'" :style="{ 'background-color': item.pod.type }">{{ item.pod.value }}</td>
                                <td :class="item.desde.changed && 'data_modified'" :style="{ 'background-color': item.desde.type }">{{ item.desde.value }}</td>
                                <td :class="item.hasta.changed && 'data_modified'" :style="{ 'background-color': item.hasta.type }">{{ item.hasta.value }}</td>
                                <td :class="item.transitTime.changed && 'data_modified'" :style="{ 'background-color': item.transitTime.type }">{{ item.transitTime.value }}</td>
                                <td :class="item.neta.changed && 'data_modified'" :style="{ 'background-color': item.neta.type }">{{ item.neta.value }}</td>
                                <td :class="item.publica.changed && 'data_modified'" :style="{ 'background-color': item.publica.type }">{{ item.publica.value }}</td>
                                <td :class="item.descuento.changed && 'data_modified'" :style="{ 'background-color': item.descuento.type }">{{ item.descuento.value }}</td>
                                <td :class="item.unidad.changed && 'data_modified'" :style="{ 'background-color': item.unidad.type }">{{ item.unidad.value }}</td>
                                <td :class="item.commodity.changed && 'data_modified'" :style="{ 'background-color': item.commodity.type }">{{ item.commodity.value }}</td>
                                <td :class="item.atmosfera.changed && 'data_modified'" :style="{ 'background-color': item.atmosfera.type }">{{ item.atmosfera.value }}</td>
                                <td :class="item.tratFrio.changed && 'data_modified'" :style="{ 'background-color': item.tratFrio.type }">{{ item.tratFrio.value }}</td>
                                <td :class="item.diasLibresOrigen.changed && 'data_modified'" :style="{ 'background-color': item.diasLibresOrigen.type }">{{ item.diasLibresOrigen.value }}</td>
                                <td :class="item.diasPlugOrigen.changed && 'data_modified'" :style="{ 'background-color': item.diasPlugOrigen.type }">{{ item.diasPlugOrigen.value }}</td>
                                <td :class="item.diasLibresDestino.changed && 'data_modified'" :style="{ 'background-color': item.diasLibresDestino.type }">{{ item.diasLibresDestino.value }}</td>
                                <td :class="item.diasPlugDestino.changed && 'data_modified'" :style="{ 'background-color': item.diasPlugDestino.type }">{{ item.diasPlugDestino.value }}</td>
                                <td :class="item.genset.changed && 'data_modified'" :style="{ 'background-color': item.genset.type }">{{ item.genset.value }}</td>
                                <td :class="item.get_out.changed && 'data_modified'" :style="{ 'background-color': item.get_out.type }">{{ item.get_out.value }}</td>
                                <td :class="item.tipoContrato.changed && 'data_modified'" :style="{ 'background-color': item.tipoContrato.type }">{{ item.tipoContrato.value }}</td>
                                <td :class="item.comentario.changed && 'data_modified'" :style="{ 'background-color': item.comentario.type }">{{ item.comentario.value }}</td>
                                <td :class="item.contratoNumero.changed && 'data_modified'" :style="{ 'background-color': item.contratoNumero.type }">{{ item.contratoNumero.value }}</td>
                                <td :class="item.contratoNumero.changed && 'data_modified'" :style="{ 'background-color': item.recargos.type }">{{ item.recargos.value }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!showTable" class="import-csv-modal__body-waiting">
                        <h1>Esperando carga de archivo...</h1>
                    </div>
                </div>
                <div class="import-csv-modal__footer">
                    <button class="btn btn-default" @click="closeModal('importCsvModal')">
                        Cerrar
                    </button>
                    <button 
                        class="btn btn-warning" 
                        @click="handleSubmit()"
                        :disabled="btnDisabled"    
                    > Importar </button>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    /**
    * @author Miguel González.
    * @description componente que lee el archivo csv desde el elemento child para procesar y validar los datos, luego se envían al backend.
     */
    import Vue from "vue";
    import { mapActions, mapState } from "vuex";
    import UiModal from "keen-ui/src/UiModal";
    import Button from '../../../../common/Button.vue';
    import VueToastify from "vue-toastify";
    import { getAcuerdosLineas, getAllContracts, sendImportDataTariffLine, getTariffRechargeTypes, listarAcuerdosLineasByIdsNotRecharges, getListasAcuerdosBase } from "../../../../../constants/lineas";
    import readXlsxFile from 'read-excel-file/web-worker';
    import { formatDate, validateFormatDecimal } from "../../../../../mixins";
    Vue.use(VueToastify);

    export default {
        data(){
            return {
                file: {},
                reader: new FileReader(),
                data: '',
                closed: false,
                showTable: false,
                modifyColor: '#0c67c9a1',
                createColor: '#2da44e',
                errorColor: '#dc143c',
                allContracts: [],
                listaColdtreatment: [],
                dataFormatted: [],
                dataProperties: [
                    'ID',
                    'Naviera',
                    'POL',
                    'POD',
                    'Desde',
                    'Hasta',
                    'TT',
                    'Neta (Costo)',
                    'Pública (Venta)',
                    'Descuento',
                    'Unidad',
                    'Commodity',
                    'Atmósfera',
                    'Trat. frío',
                    'Dias Libres Origen',
                    'Dias Plug Origen',
                    'Dias Libres Destino',
                    'Dias Plug Destino',
                    'Genset',
                    'Tipo Contrato',
                    'Comentarios',
                    'Contrato - Número ',
                    'Recargos'
                ],
                btnDisabled: true,
                showDeleteBtn: false,
            }
        },
        components: {
            UiModal,
            Button
        },
        computed: {
            ...mapState("lineas", ["dataDatatableTarifasAcuerdosLineas", "dataDatatableTarifasAcuerdosLineasFull","selectAtmospheres"]),
            ...mapState(["contratos","clientes","navieras","puertos","atmosferas","destinos","commodity","tipoContratos","contenedores", "estados"]),
        },
        methods: {
            ...mapActions(["ActionSetZindexModal"]),
            ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosLineas", "actionDataDatatableTarifasAcuerdosLineasFull", "actionSetFilterStateAcuerdosLineas"]),
            openModal(ref){
                this.closed = true;
                this.ActionSetZindexModal(true);
                this.$refs[ref].open();
            },
            closeModal(ref){
                this.closed = false;
                this.file = undefined;
                this.dataFormatted = [];
                this.showTable = false;
                this.ActionSetZindexModal(false);
                this.$refs[ref].close();
            },
            /** Primera celda no vacía para claves de Excel (incluye sufijo \\r frecuente en cabeceras). */
            pickExcelCell(element, ...keys) {
                for (const key of keys) {
                    for (const k of [key, `${key}\r`]) {
                        const v = element[k];
                        if (v !== undefined && v !== null && String(v).trim() !== "") {
                            return v;
                        }
                    }
                }
                return undefined;
            },
            /** @param { Object } payload - data que viene desde el csv para formatear a un objecto de javascript */
            formatData( payload ){
                const result = payload.map( element => {
                    //match with string
                    const foundNavieras =           this.navieras.filter( ({name}) => name.trim().toLowerCase() === element["NAVIERA"]?.trim().toLowerCase())[0]?.id; // ok
                    const foundNavieraSalida =      this.navieras.find( nav => nav.id == element["ID NAVIERA SALIDA"]); // ok
                    const foundPol =                this.puertos.filter( ({name}) => name.trim().toLowerCase() === element["POL"]?.trim().toLowerCase())[0]?.id;
                    const foundPod =                this.puertos.filter( ({name}) => name.trim().toLowerCase() === element["POD"]?.trim().toLowerCase())[0]?.id;
                    const foundContenedores =       this.contenedores.filter( ({name}) => name.trim().toLowerCase() === element["UNIDAD"]?.trim().toLowerCase())[0]?.id;
                    const foundCommodity =          this.commodity.filter( ({name}) => name.trim().toLowerCase() === element["COMMODITY"]?.trim().toLowerCase())[0]?.id;
                    const foundAtmosferas =         this.selectAtmospheres.filter( ({name}) => name.trim().toLowerCase() === element["ATMOSFERA"]?.trim().toLowerCase())[0]?.id;

                    const rawTratFrioId = this.pickExcelCell(element, "ID TRAT. FRIO", "ID TRAT FRIO", "ID TRATAMIENTO FRIO");
                    const rawTratFrioName = this.pickExcelCell(element, "TRAT. FRIO", "Trat. frío", "TRAT FRIO", "Trat frío");
                    const tratFrioById = rawTratFrioId !== undefined && !Number.isNaN(+rawTratFrioId)
                        ? this.listaColdtreatment.find(({ id }) => id === +rawTratFrioId)
                        : undefined;
                    const tratFrioByName = rawTratFrioName !== undefined
                        ? this.listaColdtreatment.find(({ name }) => name.trim().toLowerCase() === String(rawTratFrioName).trim().toLowerCase())
                        : undefined;
                    const tratFrioResolved = tratFrioById || tratFrioByName;
                    const tratFrioHasInput = rawTratFrioId !== undefined || rawTratFrioName !== undefined;
                    let foundNameTratFrio;
                    let foundIdTratFrio;
                    let tratFrioValid;
                    if (!tratFrioHasInput) {
                        foundNameTratFrio = "0";
                        foundIdTratFrio = 0;
                        tratFrioValid = true;
                    } else {
                        foundNameTratFrio = tratFrioResolved?.name ?? (rawTratFrioName !== undefined ? String(rawTratFrioName) : "");
                        foundIdTratFrio = tratFrioResolved?.id ?? 0;
                        tratFrioValid = !!tratFrioResolved;
                    }

                    // match with ids
                    const foundIdNavieras = this.navieras.filter( ({id}) => id === +element["ID NAVIERA"])[0]?.id;
                    const foundIdPol = this.puertos.filter( ({id}) => id === +element["ID POL"])[0]?.id;
                    const foundIdPod = this.puertos.filter( ({id}) => id === +element["ID POD"])[0]?.id;
                    const foundIdContenedores = this.contenedores.filter( ({id}) => id === +element["ID UNIDAD"])[0]?.id;
                    const foundIdCommodity = this.commodity.filter( ({id}) => id === +element["ID COMMODITTY"])[0]?.id;
                    const foundIdAtmosferas = this.selectAtmospheres.filter( ({id}) => id === +element["ID ATMOSFERA"])[0]?.id;
                    const foundNameNavieras = this.navieras.filter( ({id}) => id === +element["ID NAVIERA"])[0]?.name;
                    const foundNamePol = this.puertos.filter( ({id}) => id === +element["ID POL"])[0]?.name;
                    const foundNamePod = this.puertos.filter( ({id}) => id === +element["ID POD"])[0]?.name;
                    const foundNameContenedores = this.contenedores.filter( ({id}) => id === +element["ID UNIDAD"])[0]?.name;
                    const foundNameCommodity = this.commodity.filter( ({id}) => id === +element["ID COMMODITTY"])[0]?.name;
                    const foundNameAtmosferas = this.selectAtmospheres.filter( ({id}) => id === +element["ID ATMOSFERA"])[0]?.name;
                    
                    const contractNumber = this.allContracts.find(({ id }) => +id === +element["ID CONTRATO"])?.number ;
                    const contractName = this.allContracts.find(({ id }) => +id === +element["ID CONTRATO"])?.name ;

                    const newContratoNumero = contractNumber ? `${ contractNumber } - ${ contractName }` : null ;
                    
                    const recharges = element["RECARGOS"] ? element["RECARGOS"].toString().trim() : "" ;

                    return {
                        id: +element["ID"],
                        naviera: { value: !foundNavieras ? element['NAVIERA'] : foundNameNavieras, changed: false, id: foundIdNavieras ? foundIdNavieras : 0, type: (foundNavieras !== undefined && foundIdNavieras !== undefined ) ? '' : this.errorColor },
                        navieraSalida: { value: !foundNavieraSalida ? element['NAVIERA'] : foundNavieraSalida.name, changed: false, id: foundNavieraSalida ? foundNavieraSalida.id : 0, type: foundNavieraSalida !== undefined ? '' : this.errorColor },
                        pol: { value: !foundPol ? element['POL'] : foundNamePol, changed: false, id: foundIdPol ? foundIdPol : 0, type: foundPol && foundIdPol ? '' : this.errorColor },
                        pod: { value: !foundPod ? element['POD'] : foundNamePod, changed: false, id: foundIdPod ? foundIdPod : 0, type: foundPod && foundIdPod ? '' : this.errorColor },
                        desde: { value: element["DESDE"], changed: false, type: '' },
                        hasta: { value: element["HASTA"], changed: false, type: '' },
                        transitTime: { value: +element["TT"], changed: false, type: '' },
                        neta: { value: +element["NETA (COSTO)"], changed: false, type: '' },
                        publica: { value: +element["PUBLICA (VENTA)"], changed: false, type: '' },
                        descuento: { value: +element["DESCUENTO"], changed: false, type: '' },
                        unidad: { value: !foundContenedores ? element['UNIDAD'] : foundNameContenedores, changed: false, id: foundIdContenedores ? foundIdContenedores : 0, type: foundContenedores && foundIdContenedores ? '' : this.errorColor },
                        commodity: { value: !foundCommodity ? element['COMMODITY'] : foundNameCommodity, changed: false, id: foundIdCommodity ? foundIdCommodity : 0, type: foundCommodity && foundIdCommodity ? '' : this.errorColor },
                        atmosfera: { value: !foundAtmosferas ? element['ATMOSFERA'] : foundNameAtmosferas, changed: false, id: foundIdAtmosferas ? foundIdAtmosferas : 0, type: foundAtmosferas && foundIdAtmosferas ? '' : this.errorColor },
                        tratFrio: { value: foundNameTratFrio, changed: false, id: foundIdTratFrio, type: tratFrioValid ? '' : this.errorColor },
                        diasLibresOrigen: { value: +element["DIAS LIBRES ORIGEN"], changed: false, type: '' },
                        diasPlugOrigen: { value: +element["DIAS PLUG ORIGEN"], changed: false, type: '' },
                        diasLibresDestino: { value: +element["DIAS LIBRES DESTINO"], changed: false, type: '' },
                        diasPlugDestino: { value: +element["DIAS PLUG DESTINO"], changed: false, type: '' },
                        genset: { value: element["GENSET"], changed: false, type: '' },
                        get_out: { value: element["GET OUT"], changed: false, type: '' },
                        tipoContrato: { value: element["TIPO CONTRATO\r"] || element["TIPO CONTRATO"], changed: false, type: '' },
                        comentario: { value: element["COMENTARIOS"] ?? "", changed: false, type: '' },
                        contratoNumero: { value: newContratoNumero, changed: false, type: '', id: +element["ID CONTRATO"] },
                        recargos : { value: recharges, changed: false, type: '' },
                    }
                });
                return result;
            },
            /** @param { Object } newData - data que viene desde el csv */

            async matchDataStyle( newData ){

                const ids = newData.filter( d  => d.id ).map( d => d.id );

                let dataToCompare = {} ;

                if( ids.length > 0 ){
                    const tariffLines = await listarAcuerdosLineasByIdsNotRecharges({ ids }) ;

                    tariffLines.length > 0 && tariffLines.forEach( tl => dataToCompare[ tl.id ] = tl ); 

                    if( ids.length !== tariffLines.length ) return false ;
                }

                const trueCases = ["SI","SÍ","Si", "Sí", "si", "sí" ] ;

                for (const key in newData) {

                    if(newData[key].id !== 0 ){
                        const oldElement = dataToCompare[ newData[key].id ] ;

                        const fromDateArr = oldElement.from_date.split('-');
                        const toDateArr = oldElement.to_date.split('-');
                        const newFromDateArr = `${fromDateArr[2]}-${fromDateArr[1]}-${fromDateArr[0]}`;
                        const newToDateArr = `${toDateArr[2]}-${toDateArr[1]}-${toDateArr[0]}`;
                        
                        oldElement.comment = oldElement.comment ?? "" ;

                        newData[key].desde.value === newFromDateArr ? newData[key].desde.changed = false : (newData[key].desde.changed = true, newData[key].desde.type = this.modifyColor);
                        newData[key].hasta.value === newToDateArr ? newData[key].hasta.changed = false : (newData[key].hasta.changed = true, newData[key].hasta.type = this.modifyColor);
                        newData[key].transitTime.value === oldElement.transit_time ? newData[key].transitTime.changed = false : (newData[key].transitTime.changed = true, newData[key].transitTime.type = this.modifyColor);
                        newData[key].neta.value === oldElement.neta ? newData[key].neta.changed = false : (newData[key].neta.changed = true, newData[key].neta.type = this.modifyColor);
                        newData[key].publica.value === oldElement.public_value ? newData[key].publica.changed = false : (newData[key].publica.changed = true, newData[key].publica.type = this.modifyColor);
                        newData[key].descuento.value === oldElement.descuento ? newData[key].descuento.changed = false : (newData[key].descuento.changed = true, newData[key].descuento.type = this.modifyColor);
                        newData[key].diasLibresOrigen.value === oldElement.free_days_embark ? newData[key].diasLibresOrigen.changed = false : (newData[key].diasLibresOrigen.changed = true, newData[key].diasLibresOrigen.type = this.modifyColor);
                        newData[key].diasPlugOrigen.value === oldElement.plug_days_embark ? newData[key].diasPlugOrigen.changed = false : (newData[key].diasPlugOrigen.changed = true, newData[key].diasPlugOrigen.type = this.modifyColor);
                        newData[key].diasLibresDestino.value === oldElement.free_days_land ? newData[key].diasLibresDestino.changed = false : (newData[key].diasLibresDestino.changed = true, newData[key].diasLibresDestino.type = this.modifyColor);
                        newData[key].diasPlugDestino.value === oldElement.plug_days_land ? newData[key].diasPlugDestino.changed = false : (newData[key].diasPlugDestino.changed = true, newData[key].diasPlugDestino.type = this.modifyColor);
                        
                        trueCases.includes( newData[key].genset.value ) == trueCases.includes( oldElement.genset ) ? newData[key].genset.changed = false : (newData[key].genset.changed = true, newData[key].genset.type = this.modifyColor);

                        trueCases.includes( newData[key].get_out.value ) == trueCases.includes( oldElement.get_out ) ? newData[key].get_out.changed = false : (newData[key].get_out.changed = true, newData[key].get_out.type = this.modifyColor);

                        newData[key].tipoContrato.value.trim().toLowerCase() === oldElement.tipo_contrato.trim().toLowerCase() ? newData[key].tipoContrato.changed = false : (newData[key].tipoContrato.changed = true, newData[key].tipoContrato.type = this.modifyColor);
                        +newData[key].contratoNumero.id === +oldElement.tariff_contract_id ? newData[key].contratoNumero.changed = false : (newData[key].contratoNumero.changed = true, newData[key].contratoNumero.type = this.modifyColor ) ;
                        newData[key].comentario.value.trim().toLowerCase() === oldElement.comment.trim().toLowerCase() ? newData[key].comentario.changed = false : (newData[key].comentario.changed = true, newData[key].comentario.type = this.modifyColor);

                        if(newData[key].naviera.id === +oldElement.naviera_id){  
                            newData[key].naviera.changed = false;  
                            newData[key].naviera.type = '';
                        } else { 
                            newData[key].naviera.changed = true;
                            newData[key].naviera.value = this.navieras.filter( ({id}) => id === +newData[key].naviera.id)[0]?.name;
                            newData[key].naviera.type === '' ? newData[key].naviera.type = this.modifyColor : newData[key].naviera.type = this.errorColor;
                        }

                        if(newData[key].navieraSalida.id === +oldElement.naviera_salida_id){  
                            newData[key].navieraSalida.changed = false;  
                            newData[key].navieraSalida.type = '';
                        } else { 
                            newData[key].navieraSalida.changed = true;
                            newData[key].navieraSalida.value = this.navieras.filter( ({id}) => id === +newData[key].navieraSalida.id)[0]?.name;
                            newData[key].navieraSalida.type === '' ? newData[key].navieraSalida.type = this.modifyColor : newData[key].navieraSalida.type = this.errorColor;
                        }

                        if(newData[key].pol.id === +oldElement.pol_id){ 
                            newData[key].pol.changed = false; 
                        } else { 
                            newData[key].pol.changed = true;  
                            newData[key].pol.value = this.puertos.filter( ({id}) => id === +newData[key].pol.id)[0]?.name;
                            newData[key].pol.type === '' ? newData[key].pol.type = this.modifyColor : newData[key].pol.type = this.errorColor; 
                        }

                        if(newData[key].pod.id === +oldElement.pod_id){ 
                            newData[key].pod.changed = false; 
                        } else { 
                            newData[key].pod.changed = true;
                            newData[key].pod.value = this.puertos.filter( ({id}) => id === +newData[key].pod.id)[0]?.name;  
                            newData[key].pod.type === '' ? newData[key].pod.type = this.modifyColor : newData[key].pod.type = this.errorColor; 
                        }

                        if(newData[key].unidad.id === +oldElement.container_id){ 
                            newData[key].unidad.changed = false; 
                        } else { 
                            newData[key].unidad.changed = true;
                            newData[key].unidad.value = this.contenedores.filter( ({id}) => id === +newData[key].unidad.id)[0]?.name;
                            newData[key].unidad.type === '' ? newData[key].unidad.type = this.modifyColor : newData[key].unidad.type = this.errorColor;
                        }
                        if(newData[key].commodity.id === +oldElement.product_container_id){ 
                            newData[key].commodity.changed = false; 
                        } else { 
                            newData[key].commodity.changed = true;
                            newData[key].commodity.value = this.commodity.filter( ({id}) => id === +newData[key].commodity.id)[0]?.name;
                            newData[key].commodity.type === '' ? newData[key].commodity.type = this.modifyColor : newData[key].commodity.type = this.errorColor; 
                        }

                        if(newData[key].atmosfera.id === +oldElement.atmosphere_id){ 
                            newData[key].atmosfera.changed = false; 
                        } else { 
                            newData[key].atmosfera.changed = true;
                            newData[key].atmosfera.value = this.selectAtmospheres.filter( ({id}) => id === +newData[key].atmosfera.id)[0]?.name;
                            newData[key].atmosfera.type === '' ? newData[key].atmosfera.type = this.modifyColor : newData[key].atmosfera.type = this.errorColor; 
                        }

                        const oldColdId =
                            oldElement.coldtreatment_id != null && oldElement.coldtreatment_id !== ""
                                ? +oldElement.coldtreatment_id
                                : null;
                        const newColdIdRaw = newData[key].tratFrio.id;
                        const newColdId =
                            newColdIdRaw !== undefined && newColdIdRaw !== null && newColdIdRaw !== ""
                                ? +newColdIdRaw
                                : null;
                        const normalizeColdLabel = (v) => {
                            const s = String(v ?? "").trim().toLowerCase();
                            if (s === "" || s === "-") return "0";
                            return s;
                        };
                        if (oldColdId != null && newColdId != null) {
                            if (newColdId === oldColdId) {
                                newData[key].tratFrio.changed = false;
                            } else {
                                newData[key].tratFrio.changed = true;
                                newData[key].tratFrio.type = this.modifyColor;
                            }
                        } else {
                            const oldColdName = normalizeColdLabel(oldElement.coldtreatment);
                            const newColdName = normalizeColdLabel(newData[key].tratFrio.value);
                            if (oldColdName === newColdName) {
                                newData[key].tratFrio.changed = false;
                            } else {
                                newData[key].tratFrio.changed = true;
                                newData[key].tratFrio.type = this.modifyColor;
                            }
                        }

                        if(newData[key].recargos.value == oldElement.recharges){ 
                            newData[key].recargos.changed = false; 
                        } else { 
                            newData[key].recargos.changed = true;
                            newData[key].recargos.type === '' ? newData[key].recargos.type = this.modifyColor : newData[key].recargos.type = this.errorColor; 
                        }

                        if(newData[key].naviera.type === this.errorColor) newData[key].naviera.changed = true;
                        if(newData[key].pol.type === this.errorColor) newData[key].pol.changed = true;
                        if(newData[key].pod.type === this.errorColor) newData[key].pod.changed = true;
                        if(newData[key].unidad.type === this.errorColor) newData[key].unidad.changed = true;
                        if(newData[key].commodity.type === this.errorColor) newData[key].commodity.changed = true;
                        if(newData[key].atmosfera.type === this.errorColor) newData[key].atmosfera.changed = true;
                        if(newData[key].tratFrio.type === this.errorColor) newData[key].tratFrio.changed = true;

                        if(newData[key].recargos.type === this.errorColor) newData[key].recargos.changed = true;
       
                    } 

                    if(newData[key].id === 0) {
                        newData[key].naviera.changed = true;
                        newData[key].navieraSalida.changed = true;
                        newData[key].navieraSalida.type === '' ? newData[key].navieraSalida.type = this.createColor : newData[key].navieraSalida.type = this.errorColor;
                        newData[key].naviera.type === '' ? newData[key].naviera.type = this.createColor : newData[key].naviera.type = this.errorColor;
                        newData[key].pol.changed = true;
                        newData[key].pol.type === '' ? newData[key].pol.type = this.createColor : newData[key].pol.type = this.errorColor;
                        newData[key].pod.changed = true;
                        newData[key].pod.type === '' ? newData[key].pod.type = this.createColor : newData[key].pod.type = this.errorColor;
                        newData[key].desde.changed = true;
                        newData[key].desde.type = this.createColor;
                        newData[key].hasta.changed = true;
                        newData[key].hasta.type = this.createColor;
                        newData[key].transitTime.changed = true;
                        newData[key].transitTime.type = this.createColor;
                        newData[key].neta.changed = true;
                        newData[key].neta.type = this.createColor;
                        newData[key].publica.changed = true;
                        newData[key].publica.type = this.createColor;
                        newData[key].descuento.changed = true;
                        newData[key].descuento.type = this.createColor;
                        newData[key].unidad.changed = true;
                        newData[key].unidad.type === '' ? newData[key].unidad.type = this.createColor : newData[key].unidad.type = this.errorColor;
                        newData[key].commodity.changed = true;
                        newData[key].commodity.type === '' ? newData[key].commodity.type = this.createColor : newData[key].commodity.type = this.errorColor;
                        newData[key].atmosfera.changed = true;
                        newData[key].atmosfera.type === '' ? newData[key].atmosfera.type = this.createColor : newData[key].atmosfera.type = this.errorColor;
                        newData[key].tratFrio.changed = true;
                        newData[key].tratFrio.type === '' ? newData[key].tratFrio.type = this.createColor : newData[key].tratFrio.type = this.errorColor;
                        newData[key].diasLibresOrigen.changed = true;
                        newData[key].diasLibresOrigen.type = this.createColor;
                        newData[key].diasPlugOrigen.changed = true;
                        newData[key].diasPlugOrigen.type = this.createColor;
                        newData[key].diasLibresDestino.changed = true;
                        newData[key].diasLibresDestino.type = this.createColor;
                        newData[key].diasPlugDestino.changed = true;
                        newData[key].diasPlugDestino.type = this.createColor;
                        newData[key].genset.changed = true;
                        newData[key].genset.type = this.createColor;
                        newData[key].get_out.changed = true;
                        newData[key].get_out.type = this.createColor;
                        newData[key].tipoContrato.changed = true;
                        newData[key].tipoContrato.type = this.createColor;
                        newData[key].contratoNumero.changed = true;
                        newData[key].contratoNumero.type = this.createColor;
                        newData[key].comentario.changed = true;
                        newData[key].comentario.type = this.createColor;
                        newData[key].contratoNumero.id = newData.filter(({contratoNumero}) => contratoNumero.value === newData[key].contratoNumero.value)[0].contratoNumero.id;
                        newData[key].recargos.changed = true;
                        newData[key].recargos.type = this.createColor;
                    }
                }

                return true ;
            },
            /** @param { string } payload - data que se procederá a enviar para el backend */
            formatPayload(){

                const trueCases = ["SI","SÍ","Si", "Sí", "si", "sí" ] ;
                
                return this.dataFormatted.map( tariffLine =>  ({
                    id: tariffLine.id === 0 ? null : tariffLine.id ,
                    naviera_id: +tariffLine.naviera.id,
                    naviera_salida_id: +tariffLine.navieraSalida.id,
                    pol: tariffLine.pol.id,
                    pod: tariffLine.pod.id,
                    atmosphere_id: tariffLine.atmosfera.id,
                    coldtreatment_id: +tariffLine.tratFrio.id || 0,
                    container_id: tariffLine.unidad.id,
                    products_category_id: tariffLine.commodity.id,
                    public_value: tariffLine.publica.value,
                    from_date:  tariffLine.desde.value,
                    to_date:  tariffLine.hasta.value,
                    transit_time:  tariffLine.transitTime.value,
                    neta: tariffLine.neta.value,
                    contract: tariffLine.contratoNumero.value,
                    free_days_embark: tariffLine.diasLibresOrigen.value,
                    plug_days_embark: tariffLine.diasPlugOrigen.value,
                    free_days_land: tariffLine.diasLibresDestino.value,
                    plug_days_land: tariffLine.diasPlugDestino.value,
                    genset:  trueCases.includes( tariffLine.genset.value ) ? true : false,
                    get_out: trueCases.includes( tariffLine.get_out.value ) ? true : false,
                    tipo_contrato: tariffLine.tipoContrato.value,
                    tariff_contract_id: tariffLine.contratoNumero.id,
                    comment: tariffLine.comentario.value ,
                    recharges: tariffLine.recargos.value 
                }));
            },
            validContractWithNaviera( newData ){
                if(this.allContracts.filter(({ id }) => id === newData.contratoNumero.id).length > 0){
                    return +this.allContracts.filter(({ id }) => id === newData.contratoNumero.id).id === +newData.naviera.id;
                } else {
                    return false;
                }
            },

            async validFormatImport( dataToImport ){

                const quantityUpdates = dataToImport.reduce((accumulator ,item) => item.ID && (accumulator+=1) , 0) ;

                if( quantityUpdates > 3000 ){
                    this.$vToastify.warning(`El sistema no permite actualizar más de 3000 registros` , "¡Alerta!") ;
                    return false ;
                }

                let valid = true ;

                let row = 2;

                const rechargesTypesData = await getTariffRechargeTypes();

                const rechargesTypes = rechargesTypesData.data.map( d => d.code ) ;

                for ( const data of dataToImport ) {
                    
                    if( ! data['ID NAVIERA'] || isNaN( data['ID NAVIERA'] ) ){
                        this.$vToastify.error(`El campo 'ID NAVIERA' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['ID NAVIERA SALIDA'] || isNaN( data['ID NAVIERA SALIDA'] ) ){
                        this.$vToastify.error(`El campo 'ID NAVIERA SALIDA' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }
                    

                    if( ! data['ID POL'] || isNaN( data['ID POL'] ) ) {
                        this.$vToastify.error(`El campo 'ID POL' debe ser un número entero. Fila ${ row }.` , "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['ID POD'] || isNaN( data['ID POD'] )) {
                        this.$vToastify.error(`El campo 'ID POD' debe ser un número entero. Fila ${ row }.` , "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['DESDE'] ) {
                        this.$vToastify.error(`El campo 'DESDE' es requerido. Fila ${ row }.` , "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['HASTA'] ) {
                        this.$vToastify.error(`El campo 'HASTA' es requerido. Fila ${ row }.` , "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['TT'] || isNaN( data['TT'] ) ){
                        this.$vToastify.error(`El campo 'TT' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['NETA (COSTO)'] ){
                        this.$vToastify.error(`El campo 'NETA (COSTO)' es obligatorio. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['PUBLICA (VENTA)'] ){
                        this.$vToastify.error(`El campo 'PUBLICA (VENTA)' es obligatorio. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['ID UNIDAD'] || isNaN( data['ID UNIDAD'] ) ){
                        this.$vToastify.error(`El campo 'ID UNIDAD' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['ID COMMODITTY'] || isNaN( data['ID COMMODITTY'] ) ) {
                        this.$vToastify.error(`El campo 'ID COMMODITTY' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['ID ATMOSFERA'] || isNaN( data['ID ATMOSFERA'] ) ) {
                        this.$vToastify.error(`El campo 'ID ATMOSFERA' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    const rawIdTratFrio = this.pickExcelCell(data, "ID TRAT. FRIO", "ID TRAT FRIO", "ID TRATAMIENTO FRIO");
                    const rawNameTratFrio = this.pickExcelCell(data, "TRAT. FRIO", "Trat. frío", "TRAT FRIO", "Trat frío");
                    if (rawIdTratFrio !== undefined && isNaN(+rawIdTratFrio)) {
                        this.$vToastify.error(`El campo 'ID TRAT. FRIO' debe ser un número entero. Fila ${ row }.`, "¡Error!");
                        valid = false;
                        break;
                    }
                    if (rawIdTratFrio !== undefined && !this.listaColdtreatment.some(({ id }) => id === +rawIdTratFrio)) {
                        this.$vToastify.error(`El campo 'ID TRAT. FRIO' no corresponde a un tratamiento de frío válido. Fila ${ row }.`, "¡Error!");
                        valid = false;
                        break;
                    }
                    if (rawNameTratFrio !== undefined && rawIdTratFrio === undefined) {
                        const nameOk = this.listaColdtreatment.some(
                            ({ name }) => name.trim().toLowerCase() === String(rawNameTratFrio).trim().toLowerCase()
                        );
                        if (!nameOk) {
                            this.$vToastify.error(`El campo 'TRAT. FRIO' no coincide con ningún tratamiento de frío registrado. Fila ${ row }.`, "¡Error!");
                            valid = false;
                            break;
                        }
                    }

                    if( ! data['GENSET'] ) {
                        this.$vToastify.error(`El campo 'GENSET' es requerido. Fila ${ row }.` , "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['GET OUT'] ) {
                        this.$vToastify.error(`El campo 'GET OUT' es requerido. Fila ${ row }.` , "¡Error!") ;
                        valid = false ;
                        break ;
                    }

                    if( ! data['ID CONTRATO'] || isNaN( data['ID CONTRATO'] ) ) {
                        this.$vToastify.error(`El campo 'ID CONTRATO' debe ser un número entero. Fila ${ row }.`, "¡Error!") ;
                        valid = false ;
                        break ;
                    }
                    
                    if( ! validateFormatDecimal( data['NETA (COSTO)'], false ) ) {
                        this.$vToastify.warning(`El campo 'NETA (COSTO)' debe ser un número entero o númerico de decimales, máximo dos, con puntos o comas. Ej: 10 - 20,1 - 101.12 - 101,12` , `Alerta Fila ${ row }`) ;
                        valid = false ;
                        break ;
                    }

                    if( ! validateFormatDecimal( data['PUBLICA (VENTA)'], false ) ) {
                        this.$vToastify.warning(`El campo 'PUBLICA (VENTA)' debe ser un número entero o númerico de decimales, máximo dos, con puntos o comas. Ej: 10 - 20,1 - 101.12 - 101,12` , `Alerta Fila ${ row }`) ;
                        valid = false ;
                        break ;
                    }

                    let validRechargeType = true ; 

                    if( data['RECARGOS'] ){

                        for ( const rechargeType of data['RECARGOS'].split(",") ) {

                            if( ! rechargesTypes.includes( rechargeType.trim() ) ){
                                this.$vToastify.error(`El campo 'RECARGOS' contiene un tipo recargo '${ rechargeType.trim() }' no existente. Fila ${ row }.` , "¡Error!") ;
                                validRechargeType = false ;
                                break ;
                            }
                        }
                    }
                    

                    if( ! validRechargeType ){       
                        valid = false ;
                        break ;
                    } 

                    row++;
                }
                return valid ;
            },
            async formatImport( dataInput ){

                const dataImport = await readXlsxFile( dataInput ) ;

                if( dataImport.length == 0 || ! dataImport ) return [] ;

                let data = [] ;

                const headers = dataImport[0] ;

                dataImport.forEach( ( val , key ) => {

                    if( key !== 0 ){
                        let item = {} ;
                        headers.forEach( ( h, hIndex ) => item[ h ] = val[ hIndex ] ) ;
                        data.push( item ) ;
                    }
                }) ;

                data = data.map( d => ({ ...d, DESDE : typeof d.DESDE == "string" ? d.DESDE : formatDate( new Date( d.DESDE ) )  }) );
                data = data.map( d => ({ ...d, HASTA : typeof d.HASTA == "string" ? d.HASTA : formatDate( new Date( d.HASTA ) )  }) );
                
                return data ;
            },
            resetTable(){
                this.dataFormatted = [] ;
                this.btnDisabled = true ;
                this.showTable = false ;
                this.$vToastify.stopLoader();
                document.getElementById('fileToImport').value === '' ? this.showDeleteBtn = false : this.showDeleteBtn = true;
            },
            async getFile() {

                const fileToImport = document.getElementById('fileToImport').value ;
                
                if( fileToImport === '' ) return this.resetTable();

                this.$vToastify.loader("Cargando Información...");

                try {
                    const data = await this.formatImport( this.$refs.fileToImport.files[0] ) ;
                    
                    const valid = await this.validFormatImport( data ) ;

                    if( ! valid ) return this.resetTable();

                    this.dataFormatted = this.formatData( data );

                    const response = await this.matchDataStyle( this.dataFormatted ) ;

                    if( ! response ){
                        this.data = '';
                        this.resetTable() ;
                        return this.$vToastify.warning( "Error de id. Favor, validar que id's no estén eliminados o pertenezcan al país que se están subiendo.", "!Alerta!");
                    } 

                    this.showDeleteBtn = fileToImport === '' ? false : true ;

                    this.showTable = true;
                    this.btnDisabled = false ;

                    this.$vToastify.stopLoader();
                    
                } catch (error) {
                    this.data = '';
                    this.resetTable();
                    return this.$vToastify.error( "Hubo un error al leer Excel. Favor, recargue la página e intente nuevamente.", "¡Error!");
                }
            },
            clearInput(){
                document.getElementById('fileToImport').value = '';
                this.resetTable();
            },
            async rechargeData(){

                const { data_table } = await getAcuerdosLineas();

                this.actionSetDataListarTarifasAcuerdosLineas( data_table );

            },
            async handleSubmit(){

                this.$vToastify.loader("Realizando Solicitud...");

                const form = { tariff_lines : this.formatPayload() } ;

                try{
                    const {data} = await sendImportDataTariffLine( form );

                    await this.rechargeData() ;
                    
                    this.$vToastify.stopLoader();

                    this.closeModal('importCsvModal') ;

                    data.forEach(message => {

                      this.$vToastify.success(message, "Importación exitosa");

                    });

                }
                catch( error ){
                    this.$vToastify.stopLoader();
                    return this.$vToastify.error( "Hubo un error al importar Excel. Favor, recargue la página e intente nuevamente.", "¡Error!");
                }
                
            },
        },
        watch: {
          
        },
        async created() {
            const [contractsRes, listas] = await Promise.all([
                getAllContracts(),
                getListasAcuerdosBase(),
            ]);
            this.allContracts = contractsRes.data;
            this.listaColdtreatment = listas.lista_coldtreatment || [];
        }
    }
</script>

<style lang="scss" scoped>
    $error-color: #dc143c;
    $modify-color: #0c67c9a1;
    $create-color: #2da44e;
    $border-dashed-color: #575a57;

    #idImportarCsvModal .ui-modal__container {
            width: 87% !important;
    }

    #idImportarCsvModal  input[type=file] {
        display: block;
    }

    @mixin fullStretch(){
        width: 100%;
        height: 100%;
    }
    .import-csv-modal{
        width: 80vw;
        height: 80vh; 
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 4rem 1fr 4rem;

        &__header {
            grid-column: 1/2;
            grid-row: 1/2;
            display: flex;
            gap: 5px;

            &-import {
                @include fullStretch();
            }

            &-info {
                @include fullStretch();
                padding: 0 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                &-span {
                    width: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 10px;

                    &-error {
                        width: 20px;
                        height: 20px;
                        border-radius: 3px;
                        background-color: $error-color;
                    }
                    &-modify {
                        width: 20px;
                        height: 20px;
                        border-radius: 3px;
                        background-color: $modify-color;
                    }
                    &-create {
                        width: 20px;
                        height: 20px;
                        border-radius: 3px;
                        background-color: $create-color;
                    }
                }
            }
        }

        &__body {
            @include fullStretch();
            grid-column: 1/2;
            grid-row: 2/3;
            overflow: auto;
            
            &-waiting {
                @include fullStretch();
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1.5px dashed $border-dashed-color;

                h1 {
                    color: $border-dashed-color;
                }
            }
        }

        &__footer {
            grid-column: 1/2;
            grid-row: 3/4;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .data_modified {
        border-radius: 5px;
        color: #fff;
    }

    .btn-import-csv {
        margin-left: 75px;
        margin-top: 7.7px;

        &:hover {
            margin-bottom: 7.7px;
        }
    }
    .import-file {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        &__input {
            width: inherit;
            cursor: pointer;
            border: 1.5px #575a57 dashed;
            border-radius: 3px;

            &::-webkit-file-upload-button {
                visibility: hidden;
            }

            &::before {
                color: white;
                content: 'Seleccione archivo';
                display: inline-block;
                background: #575a57;
                border-radius: 3px;
                padding: 5px 8px;
                outline: none;
                white-space: nowrap;
                -webkit-user-select: none;
                cursor: pointer;
            }
        }

        &__delete {
            position: absolute;
            left: 97%;
            font-size: 1.2rem;
            color: #dc143c;
            cursor: pointer;
            transition: transform .3s ease-out;

            &:hover {
                transform: scale(1.5);
            }
        }
    }
</style>